import { BookingPriceRequest, Cartridge, CartridgeVariant } from '@markant-platform/cartridge/model';
import { User } from '@markant-platform/shared/user/model';
import { FormControl, FormGroup } from '@angular/forms';
import { OrganizationDetailData } from 'data-model';

export type BookingWorkflowData = {
  cartridge: Cartridge;
  variant: CartridgeVariant;
  user: User;
  organization: OrganizationDetailData;
  priceRequest?: BookingPriceRequest;
  billingEmail?: string;
  billingLanguageIsoCode?: string;
  references?: {
    customerCartridgeReferenceId?: string;
    costCenter?: string;
    otherReferences?: string;
  };
  serviceGtcAccepted: boolean;
};

export type UpgradeWorkflowData = BookingWorkflowData & {
  bookingId: string;
  bookingVersion: number;
};

export type Step = 'form' | 'overview' | 'confirmation';

export type ReferencesForm = FormGroup<{
  customerCartridgeReferenceId: FormControl<string | null>;
  costCenter: FormControl<string | null>;
  otherReferences: FormControl<string | null>;
}>;

export type BookingDataForm = FormGroup<{
  billingEmail: FormControl<string | null>;
  billingLanguageIsoCode: FormControl<string | null>;
  references: ReferencesForm;
}>;

export const BookingUpgradeStateMap: Record<string, { color: string; icon: string; label: string }> = {
  UPGRADE_REQUEST_OPEN: {
    label: 'upgrade.pfa.state.UPGRADE_REQUEST_OPEN',
    color: 'warning',
    icon: 'm_new-small',
  },
  UPGRADE_REQUEST_APPROVED: {
    label: 'upgrade.pfa.state.UPGRADE_REQUEST_APPROVED',
    color: 'warning',
    icon: 'm_new-small',
  },
};
